import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Donut from '../component/Donut'
import R from 'ramda'
import { EventContribTable } from '../component/EventsContribTable'
import { getUnitMap } from 'analytics/selectors'
import { fromNullable } from 'data.maybe'
import { format, pctFormatter } from '../utils'

import { Icon } from 'antd'

const contribPieVal = ({ detailContrib }) => detailContrib
const eventKey = ({ unitId, year, eventNum }) => `${unitId}-${year}-${eventNum}`
const identifyEvent = ({ unitId, year, eventNum }) => ({
  unitId,
  year,
  eventNum,
})
const eventTooltip = unitMap => ({ unitId, year, eventNum, detailContrib }) =>
  `${unitMap[unitId]} ${year} ${eventNum}: ${detailContrib}%`

const unitFilter = unitId => d => unitId === d.unitId

const Header = styled.h2`
  text-align: center;
  font-size: 2em;
  color: #444;
  margin-bottom: 0px;
`

const matchData = (a, b) => a.unitId === b.unitId && a.year === b.year && a.eventNum === b.eventNum

class ContribDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: undefined,
    }
    this.select = this.select.bind(this)
  }

  select(selected) {
    this.setState({
      selected,
    })
  }

  render() {
    const {
      ident,
      events,
      width,
      height,
      unitMap,
      // value,
      next,
      contrib,
      previous,
      dataFilter,
      contribEntity,
      colorScheme,
      // hoverColor,
      title,
    } = this.props
    const { selected } = this.state

    let filteredEvents = events.filter(dataFilter)

    const sumContrib = filteredEvents.map(a => a.value).reduce((a, b) => a + b, 0)

    filteredEvents = filteredEvents.map(d => ({
      ...d,
      detailContrib: Math.round((d.value / sumContrib) * 10000) / 100,
    })) // .sort( (a,b) => b.unitEford-a.unitEford)

    const donutWidth = Math.min(height / 2, width)

    const donutProps = {
      width: donutWidth,
      height: donutWidth,
      data: filteredEvents,
      pieVal: contribPieVal,
      sliceKey: eventKey,
      colorVal: eventKey,
      tooltip: eventTooltip(unitMap),
      label: [contrib, 'Contribution', 'to Fleet'],
      select: this.select,
      identifySelection: identifyEvent,
      fontSizeMultipler: 0.7,
      colorScheme,
      selected,
      matchData,
    }

    const tableProps = {
      width,
      height:
        height / 2 -
        fromNullable(title)
          .map(_ => 30)
          .getOrElse(0),
      events: filteredEvents,
      unitMap,
      showDetailContrib: true,
      selected,
      detailContribEntity: contribEntity,
    }

    const DonutContainer = styled.div`
      display: flex;
      align-items: center;
    `
    const Arrow = styled(Icon)`
      flex: 1 0 96px;
    `
    const CenterDonut = styled(Donut)`
      flex: 0 0 ${donutWidth}px;
    `

    return (
      <div>
        {fromNullable(title)
          .map(t => <Header key={t}>{t}</Header>)
          .getOrElse(null)}
        <DonutContainer>
          <Arrow
            title="Less Contribution"
            type="arrow-left"
            link
            onClick={() => previous(ident)}
            color="grey"
            size="massive"
          />
          <CenterDonut {...donutProps} />
          <Arrow
            title="More Contribution"
            name="arrow-right"
            link
            onClick={() => next(ident)}
            color="grey"
            size="massive"
          />
        </DonutContainer>
        <EventContribTable {...tableProps} />
      </div>
    )
  }
}

const unitMapStateToProps = (state, { unitId, contrib, aggregate }) => ({
  events: fromNullable(contrib)
    .chain(co => fromNullable(co.event))
    .getOrElse([]),
  unitMap: getUnitMap(state),
  contrib: fromNullable(contrib)
    .chain(co => fromNullable(co.unit))
    .chain(u => fromNullable(R.find(d => d.unitId === unitId, u)))
    .map(u => format(u.value, pctFormatter))
    .getOrElse('N/A'),
  value: fromNullable(aggregate)
    .chain(ag => fromNullable(ag.unitAggregate))
    .chain(units => fromNullable(units[unitId]))
    .map(d => `${d}`)
    .getOrElse('N/A'),
  dataFilter: unitFilter(unitId),
  contribEntity: 'Unit',
  ident: unitId,
  title: fromNullable(aggregate)
    .chain(ag => fromNullable(ag.unitAggregate))
    .chain(units => fromNullable(units[unitId]))
    .map(d => `${getUnitMap(state)[unitId]} EFORd ${d}`)
    .getOrElse(getUnitMap(state)[unitId]),
})

const causeCodeMapStateToProps = (state, { causeCode, contrib /* aggregate */ }) => {
  const events = fromNullable(contrib)
    .chain(co => fromNullable(co.event))
    .getOrElse([])

  const getTitle = R.compose(
    event =>
      fromNullable(event)
        .chain(e => fromNullable(e.description).map(des => `${causeCode} - ${des}`))
        .getOrElse(`Cause Code ${causeCode}`),
    R.find(e => e.causeCode === causeCode)
  )

  return {
    events,
    unitMap: getUnitMap(state),
    contrib: fromNullable(contrib)
      .chain(co => fromNullable(co.causeCode))
      .chain(u => fromNullable(R.find(d => d.code === causeCode, u)))
      .map(u => format(u.value, pctFormatter))
      .getOrElse('N/A'),
    dataFilter: d => d.causeCode === causeCode,
    contribEntity: 'Cause Code',
    ident: causeCode,
    title: getTitle(events),
  }
}

export const UnitContribDetail = connect(unitMapStateToProps)(ContribDetail)

export const CauseContribDetail = connect(causeCodeMapStateToProps)(ContribDetail)
